'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-fares-tooltip-template.html'));
var ChartDashboardClassFareController = function ChartDashboardClassFareController($q, $rootScope, $scope, $filter, ChartDashboardClassFareService, chartFormatter, dashboardCommonService) {
  $scope.cogChannel = 'chart-dashboard-class-fare';
  $scope.title = 'Product Group Fare Comparison';
  // className or classGroupName
  $scope.cogOptionsSelected = 'className';
  $scope.cogOptions = require('../config/cogOptions.json');
  var allCogItems = [{
    styleClass: 'yellow'
  }, {
    label: 'Bookings YOY',
    styleClass: 'blue'
  }, {
    label: 'Avg Fare YOY',
    style: 'circle'
  }];
  var cogOptionsLegendMapping = {
    'className': allCogItems,
    'classGroupName': allCogItems.slice(0, 2)
  };
  var legendTitlesMapping = {
    'className': 'Class Fare and Bookings Comparison',
    'classGroupName': 'Product Group Fare and Bookings Comparison'
  };
  $scope.legend = cogOptionsLegendMapping[$scope.cogOptionsSelected];
  $scope.legendTitle = legendTitlesMapping[$scope.cogOptionsSelected];
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.chartFormatters = {
    xAxisTickFormatter: chartFormatter.identity,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return chartFormatter.humanReadable(d) + '%';
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var data = _.cloneDeep(d);
      var tooltipModel = _.assign(data, {
        groups: $scope.cogOptionsSelected === 'classGroupName',
        barTitle: data.stackLabel,
        formatter: _.partialRight(rmNumberFormat, 'NUMBER')
      });
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'dashboard-class-fare-chart-tooltip';
  $scope.prepareChartData = function (data) {
    $scope.dataSummary = ChartDashboardClassFareService.getDataSummary();
    return data;
  };
  function updateCarousel() {
    $rootScope.$broadcast('reload-carousel');
  }
  $scope.reloadChart = function () {
    ChartDashboardClassFareService.getData($scope.cogOptionsSelected).then($scope.prepareChartData).then($scope.renderChart).then(updateCarousel).then(function () {
      $scope.$broadcast('perfect-scrollbar:update');
    });
  };
  $scope.onDataRepresentationChange = function (value) {
    $scope.updateCogOptions(value);
    $scope.cogOptionsSelected = value;
    $scope.legend = cogOptionsLegendMapping[value];
    $scope.legendTitle = legendTitlesMapping[value];
    $scope.reloadChart();
  };
  $scope.setDefaultView = function () {
    $scope.cogOptionsSelected = 'className';
    $scope.updateCogOptions('className');
  };
  $scope.updateCogOptions = function (value) {
    $scope.cogOptions.defaults['no-submenu']['no-group'] = [value];
  };
  $scope.checkVisibilityAndReload = function () {
    var isVisible = dashboardCommonService.isOneMarketSelected() && dashboardCommonService.selectionHasData();
    $scope.setChartVisibility(isVisible);
    if (isVisible) {
      $scope.reloadChart();
    }
  };
};
ChartDashboardClassFareController.$inject = ['$q', '$rootScope', '$scope', '$filter', 'ChartDashboardClassFareService', 'FormatterService', 'DashboardCommonService'];
module.exports = ChartDashboardClassFareController;